import PropTypes from "prop-types";
import React from "react";
import MovieItemContext from "./MovieContext";
import { Link } from "react-router-dom";
// export default function MovieItem({ url, title, img, movieId }) {
//   return (
//     <MovieItemContext.Provider value={{ title, img, movieId }}>
//       <div className="relative movile__item">
//         <img src={`${img}`} alt="" className="movie__item--img" />
//         <div className="z-50 movie__item--desc">
//           {/* <Heart /> */}

//           {
//             <div className="desc--items">
//               <div>
//                 <h2 className="movie__title">{title}</h2>
//               </div>
//               <div>
//                 <a
//                   href={`${url}`}
//                   className="px-6 py-2 text-base font-bold btn btn-white md:text-lg xl:px-8 xl:py-2 "
//                 >
//                   View Details
//                 </a>
//               </div>
//             </div>
//           }
//         </div>
//       </div>
//     </MovieItemContext.Provider>
//   );
// }

export default function MovieItem({
  url,
  title,
  img,
  movieId,
  releaseDate,
  rating,
}) {
  return (
    <MovieItemContext.Provider value={{ title, img, movieId }}>
      <Link to={url} className="w-full h-full">
        <div className="flex flex-col w-full h-full ">
          <div className="relative flex-1 w-full h-full overflow-hidden movie__item">
            <img src={`${img}`} alt="" className="movie__item--img" />
          </div>
          <div className="z-50 py-3">
            <h2 className="text-sm md:text-lg">{title}</h2>
            <div className="flex flex-wrap items-center mt-1 text-md">
              <svg
                className="w-6 h-6 mr-1 text-orange-500 fill-current "
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.562 18.841c-1.02.524-2.21-.322-2.016-1.431l.656-3.74-2.78-2.649c-.826-.785-.37-2.154.77-2.316l3.843-.545 1.719-3.403c.51-1.01 1.982-1.01 2.492 0l1.72 3.403 3.843.545c1.14.162 1.595 1.53.77 2.316l-2.781 2.649.656 3.74c.195 1.109-.997 1.955-2.016 1.431L12 17.075l-3.438 1.766z"
                />
              </svg>
              <p className="text-xs md:text-base">{rating}%</p>
              <p className="mx-2">|</p>
              <p className="text-xs lg:text-base">{releaseDate}</p>
            </div>
          </div>
        </div>
      </Link>
    </MovieItemContext.Provider>
  );
}
MovieItem.defaultProps = {
  title: "This is a title",
  img: "https://image.tmdb.org/t/p/w400/3iYQTLGoy7QnjcUYRJy4YrAgGvp.jpg",
  movieId: "thisisasdfas",
};
MovieItem.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  movieId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired,
};
